<template>
  <!-- Matches the real chart card's outer shape (header + h-350-px body) so swapping
       it out for the actual <card-line-chart>/<card-bar-chart> once data arrives
       doesn't cause a layout jump. -->
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 border border-blueGray-200 rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1 animate-pulse">
          <div class="h-2 w-20 bg-blueGray-200 rounded mb-2"></div>
          <div class="h-4 w-36 bg-blueGray-200 rounded"></div>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto">
      <div class="relative h-350-px flex items-end justify-between gap-2 animate-pulse">
        <div
          v-for="(h, n) in barHeights"
          :key="n"
          class="bg-blueGray-200 rounded flex-1"
          :style="{ height: h + '%' }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "chart-skeleton",
  data() {
    return {
      // Fixed, uneven heights so the placeholder actually reads as "a chart about to
      // appear" rather than a flat gray block.
      barHeights: [45, 70, 55, 85, 60, 40, 75]
    };
  }
};
</script>
